<script>
  import { computed } from '@nuxtjs/composition-api'

  export default {
    props: {
      partners: {
        type: Array,
        default: null
      }
    },
    setup (props) {
      const filteredPartners = computed(() => {
        if (props.partners) {
          return props.partners.filter(partner => !!partner.value)
        }
        return []
      })

      const hasPartners = computed(() => {
        return filteredPartners.value.length
      })

      return {
        hasPartners,
        filteredPartners
      }
    }
  }
</script>

<template>
  <div v-if="hasPartners">
    <p class="text-base font-bold leading-relaxed">
      of bestel dit product op
    </p>
    <ul class="flex mt-4 space-x-2">
      <li
        v-for="partner in filteredPartners"
        :key="partner.name"
        class=""
      >
        <a
          :href="partner.value"
          target="_blank"
          class="flex items-center justify-center p-2 transition-all bg-blue-100 cursor-pointer h-18 w-18 rounded-4 hover:bg-blue-200"
        >
          <img
            :src="partner.image"
            :alt="partner.name"
            class="w-12"
          >
        </a>
      </li>
    </ul>
  </div>
</template>
